import ChatAttachmentChips from "../ChatAttachmentChips";
import type { ChatMessage } from "@lib/agent/types";
import { Paper, Stack, Text, useComputedColorScheme } from "@mantine/core";

export default function UserChatMessage({ message }: { message: ChatMessage }) {
  const attachments = message.attachments ?? [];
  const colorScheme = useComputedColorScheme();

  return (
    <Stack flex={1} w="100%" align="flex-end">
      {attachments.length > 0 && (
        <ChatAttachmentChips items={attachments.map((a, i) => ({ key: `${a.filename}-${i}`, filename: a.filename }))} />
      )}
      <Paper
        py={5}
        px="sm"
        radius="lg"
        bg={colorScheme === "dark" ? "var(--mantine-color-default-border)" : "var(--mantine-color-gray-light-hover)"}
        shadow="xxs"
        withBorder={false}
        maw="90%"
        mb="md"
      >
        <Text size="sm" fw={500} c="var(--mantine-color-bright)" style={{ overflowWrap: "break-word" }}>
          {message.content}
        </Text>
      </Paper>
    </Stack>
  );
}
